export default __webpack_public_path__ + "static/media/viber-logo.994f309e.webp";